/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React, { Component } from 'react';
import Carousel from '@brainhubeu/react-carousel';
import PropTypes from 'prop-types';
import styles from './UpsellProduct.module.css';
import './UpsellProductBrandRefresh.module.css';
import ProductCard from '../../components/ProductCard/ProductCard';
import {
  getCheckoutPartProps,
  isReviewOrderBrandRefresh,
} from '../ReviewOrder/reviewOrderBrandRefreshClasses';

const carouselArrowIcon = require('./imgs/carousel-icon.svg');
const arrowLeftIcon = require('./imgs/brand-refresh-arrow-left.svg');
const arrowLeftDisabledIcon = require('./imgs/brand-refresh-arrow-left-disabled.svg');
const arrowRightIcon = require('./imgs/brand-refresh-arrow-right.svg');
const arrowRightDisabledIcon = require('./imgs/brand-refresh-arrow-right-disabled.svg');

class UpsellProduct extends Component {

    constructor(props) {
        super(props);
        this.suggestedRow = React.createRef();
        this.state = {
            slideValue: 0,
            slidesPerPage: 3,
            canScrollPrev: false,
            canScrollNext: false,
            showSuggestedNav: false,
        }
    }

    componentDidMount() {
        this.handlePageResize();
        window.addEventListener('resize', this.handlePageResize);
        this.scheduleSuggestedNavUpdate();
    }

    componentDidUpdate(prevProps) {
        const { order } = this.props;
        const prevCount = prevProps.order?.upsellProducts?.length ?? 0;
        const nextCount = order?.upsellProducts?.length ?? 0;
        if (prevCount !== nextCount) {
            this.scheduleSuggestedNavUpdate();
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handlePageResize);
    }

    scheduleSuggestedNavUpdate = () => {
        const runUpdate = () => this.updateSuggestedNav();
        if (typeof window.requestAnimationFrame === 'function') {
            window.requestAnimationFrame(() => {
                window.requestAnimationFrame(runUpdate);
            });
            return;
        }
        runUpdate();
    };

    mobileCarouselSlide = (descend) => {
        const { slideValue } = this.state;
        this.setState({ slideValue: descend ? slideValue - 1 : slideValue + 1 });
    };

    handlePageResize = () => {
        this.setState({ slidesPerPage: window.innerWidth <= 1000 ? 1.25 : 3 });
        this.scheduleSuggestedNavUpdate();
    };

    updateSuggestedNav = () => {
        const row = this.suggestedRow.current;
        if (!row) {
            return;
        }
        const maxScroll = row.scrollWidth - row.clientWidth;
        const hasOverflow = maxScroll > 1;
        this.setState({
            showSuggestedNav: hasOverflow,
            canScrollPrev: hasOverflow && row.scrollLeft > 1,
            canScrollNext: hasOverflow && row.scrollLeft < maxScroll - 1,
        });
    };

    scrollSuggestedRow = (direction) => {
        const row = this.suggestedRow.current;
        if (!row) {
            return;
        }
        const slide = row.firstElementChild;
        const gap = parseFloat(window.getComputedStyle(row).columnGap) || 0;
        const step = slide ? slide.getBoundingClientRect().width + gap : row.clientWidth;
        if (typeof row.scrollBy === 'function') {
            row.scrollBy({ left: direction * step, behavior: 'smooth' });
            return;
        }
        row.scrollLeft += direction * step;
    };

    renderSuggestedNav = () => {
        const { canScrollPrev, canScrollNext, showSuggestedNav } = this.state;
        if (!showSuggestedNav) {
            return null;
        }
        return (
          <div data-part={getCheckoutPartProps('suggested-items-nav')}>
            <button
              type="button"
              disabled={!canScrollPrev}
              onClick={() => this.scrollSuggestedRow(-1)}
              aria-label="Previous suggested items"
              data-part={getCheckoutPartProps('suggested-items-prev')}
            >
              <img
                alt=""
                src={canScrollPrev ? arrowLeftIcon : arrowLeftDisabledIcon}
                width={16}
                height={16}
              />
            </button>
            <button
              type="button"
              disabled={!canScrollNext}
              onClick={() => this.scrollSuggestedRow(1)}
              aria-label="Next suggested items"
              data-part={getCheckoutPartProps('suggested-items-next')}
            >
              <img
                alt=""
                src={canScrollNext ? arrowRightIcon : arrowRightDisabledIcon}
                width={16}
                height={16}
              />
            </button>
          </div>
        );
    };

    renderProductCards = () => {
        const { order } = this.props;
        const isBrandRefresh = isReviewOrderBrandRefresh();
        return order.upsellProducts.map((item) => {
            const isBox = item.hasAssortments;
            const isCustom = !isBox && (item.options && item.options.length > 0);
            return (
              <div
                className={isBrandRefresh ? undefined : styles.carouselSlide}
                key={item.id}
                data-part={getCheckoutPartProps('cross-sell-slide')}
              >
                <ProductCard
                  isCustom={isCustom}
                  isUpsale
                  isBox={isBox}
                  isCrossSell={isReviewOrderBrandRefresh()}
                  primaryImage={item.productImage}
                  type="small"
                  id={item.id}
                  title={item.title}
                  price={item.price}
                  categories={item.categories}
                  afterProductAdded={this.viewOrderDetails}
                />
              </div>
            );
        });
    };

    upsellProductContainer = () => {
        const {slideValue, slidesPerPage} = this.state;
        const {order} = this.props;
        const isBrandRefresh = isReviewOrderBrandRefresh();
        const title = order.upsellProducts.length ? (
          <h2
            className={isBrandRefresh ? undefined : 'text-dark dark:text-white'}
            data-part={getCheckoutPartProps('suggested-items-title')}
          >
            Suggested items
          </h2>
        ) : null;

        return(
          <div
            className={styles.carouselWrapper}
            data-part={getCheckoutPartProps('suggested-items')}
          >
            <div
              className={styles.carouselHeader}
              data-part={getCheckoutPartProps('suggested-items-header')}
            >
              {isBrandRefresh ? (
                <div data-part={getCheckoutPartProps('suggested-items-header-top')}>
                  {title}
                  {this.renderSuggestedNav()}
                </div>
              ) : title}
              {isBrandRefresh ? null : (
                <div className={styles.carouselDots}>
                  {slideValue !== 0 ? (
                    <img
                      onClick={() => this.mobileCarouselSlide(true)}
                      alt=""
                      src={carouselArrowIcon}
                      aria-hidden="true"
                    />
                    ) : null}
                  {order.upsellProducts.map((item, index) => {
                        const isChosen = slideValue === index;
                        const tooltipId = `upsell-tooltip-${index}`;
                        return (
                          <div key={index} className="has-tooltip" style={{ position: 'relative', display: 'inline-block' }}>
                            <div
                              title="upsell-products"
                              onClick={() => this.setState({ slideValue: index })}
                              role="button"
                              tabIndex={0}
                              aria-label={`Select upsell product ${index + 1}`}
                              aria-labelledby={tooltipId}
                              onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") {
                                  e.preventDefault();
                                  this.setState({ slideValue: index });
                                }
                              }}
                              onFocus={(e) => {
                                const tooltipContainer = e.currentTarget.closest('.has-tooltip');
                                const tooltip = tooltipContainer?.querySelector(`#${tooltipId}`);
                                if (tooltip) {
                                  tooltip.setAttribute('aria-hidden', 'false');
                                  tooltip.classList.add('tooltip-visible');
                                  // Force visibility with inline styles using setProperty for !important
                                  tooltip.style.setProperty('visibility', 'visible', 'important');
                                  tooltip.style.setProperty('display', 'block', 'important');
                                  tooltip.style.setProperty('opacity', '1', 'important');
                                }
                              }}
                              onBlur={(e) => {
                                // Delay hiding to allow focus to move to tooltip if needed
                                setTimeout(() => {
                                  const tooltipContainer = e.currentTarget.closest('.has-tooltip');
                                  const tooltip = tooltipContainer?.querySelector(`#${tooltipId}`);
                                  const {activeElement} = document;
                                  // Don't hide if focus moved to tooltip or button
                                  if (tooltip && !tooltip.contains(activeElement) && activeElement !== e.currentTarget) {
                                    tooltip.setAttribute('aria-hidden', 'true');
                                    tooltip.classList.remove('tooltip-visible');
                                    tooltip.style.setProperty('visibility', 'hidden', 'important');
                                    tooltip.style.setProperty('display', 'none', 'important');
                                  }
                                }, 100);
                              }}
                              className={[
                                styles.dot,
                                isChosen ? styles.activeDot : null
                              ].join(" ")}
                            />
                            <span
                              id={tooltipId}
                              className="tooltip rounded shadow-lg p-1 bg-[#ce4396] text-white mt-6 px-2 py-1"
                              role="tooltip"
                              aria-hidden="true"
                              style={{
                                position: 'absolute',
                                bottom: '100%',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                marginBottom: '8px',
                                whiteSpace: 'nowrap',
                                zIndex: 50,
                                visibility: 'hidden',
                                display: 'none'
                              }}
                            >
                              Select upsell product 
                              {' '}
                              {index + 1}
                            </span>
                          </div>
                        );
                    })}
                </div>
              )}
            </div>
            {isBrandRefresh ? (
              <div
                className={styles.brandSuggestedRow}
                data-part={getCheckoutPartProps('suggested-items-row')}
                ref={this.suggestedRow}
                onScroll={this.updateSuggestedNav}
              >
                {this.renderProductCards()}
              </div>
            ) : (
              <Carousel
                arrowLeft={(
                  <img
                    alt="arrow-left"
                    className={styles.arrow}
                    src={carouselArrowIcon}
                  />
                    )}
                arrowLeftDisabled={() => null}
                arrowRight={(
                  <img
                    alt=""
                    className={[styles.arrow, styles.arrowRight].join(' ')}
                    src={carouselArrowIcon}
                  />
                    )}
                arrowRightDisabled={() => null}
                addArrowClickHandler
                slidesPerPage={slidesPerPage}
                onChange={(value) => this.setState({ slideValue: value })}
                value={slideValue}
                arrows
              >
                {this.renderProductCards()}
              </Carousel>
            )}
          </div>
        );
    };

    render() {
        const { order } = this.props;
        if (!order?.upsellProducts || order.upsellProducts.length === 0) {
            return null;
        }
        return <this.upsellProductContainer />;
    }
}

UpsellProduct.propTypes = {
    order: PropTypes.shape().isRequired
}

export default UpsellProduct;
